import { ThemeType } from "../../models/enums/theme.enum";
import { MenuEntry } from "../../../modules/protected/components/menu/models/menu.model";
import { TecComModuleType } from "shared-states";
import { UserViewLandingPage } from "../../models/enums/user-type.enum";

export interface ShellStateModel {
  defaultMenu: MenuEntry[];
  userMenu: MenuEntry[];
  userViewLandingPage?: UserViewLandingPage;
  theme: ThemeType;
  isInitialized: boolean;
  activeModule?: TecComModuleType;
  error?: Error;
  activeMenuRoutePath: string;
}
